import { Card, Col, Row, message } from "antd";
import { getCustomerById } from "api/coreapi/customers";
import LoadingSpinner from "components/common/loadingSpinner/loadingSpinner";
import { PageTitle } from "components/common/pageTitle/pageTitle";
import { CustomerStatuses } from "constants/customers";
import { OrderForm, OrderFormContext } from "features/orders/orderForm";
import { useAppSelector } from "hooks/useAppSelector";
import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { CustomerOverview } from "shared/models/customerOverviewModel";

interface CreateOrderPageProps {
    context?: OrderFormContext;
}

function CreateOrderPage({ context = 'customer' }: CreateOrderPageProps) {
    const currentUserCustomer = useAppSelector(store => store.currentUser?.customer);
    const [searchParams] = useSearchParams();
    const [initialCustomer, setInitialCustomer] = useState<CustomerOverview>();
    const [loadingCustomer, setLoadingCustomer] = useState(false);
    const isAdministrative = context === 'administrative';
    const initialCustomerId = searchParams.get('customerId');

    useEffect(() => {
        const loadInitialCustomer = async () => {
            if (!isAdministrative || !initialCustomerId) {
                return;
            }

            setLoadingCustomer(true);
            try {
                const response = await getCustomerById(initialCustomerId);
                const customer = response.result;
                if (customer) {
                    setInitialCustomer({
                        id: customer.id,
                        identificationNumberTypeId: customer.identificationNumberTypeId,
                        identificationNumberTypeName: customer.identificationNumberTypeName,
                        identificationNumber: customer.identificationNumber,
                        name: customer.name,
                        customerStatusId: customer.customerStatusId,
                        customerStatusName: customer.customerStatusName,
                        isRegistered: customer.isRegistered,
                        createdOn: customer.createdOn,
                    });
                }
            }
            catch {
                message.error('No fue posible precargar el cliente seleccionado.');
            }
            finally {
                setLoadingCustomer(false);
            }
        };

        loadInitialCustomer();
    }, [initialCustomerId, isAdministrative]);

    if (!isAdministrative && currentUserCustomer?.customerStatusId !== CustomerStatuses.Active) {
        return (<>Ups, parece que tu perfil de cliente no se ha activado aún, no puedes crear órdenes de servicio.</>);
    }

    if (loadingCustomer) {
        return <LoadingSpinner />;
    }

    return (
        <Row justify={"center"}>
            <Col md={{ span: 16 }} span={24}>
                <Card>
                    <PageTitle>Nueva orden de servicio</PageTitle>
                    <OrderForm context={context} initialCustomer={initialCustomer} />
                </Card>
            </Col>
        </Row>
    );
}

export default CreateOrderPage;
